import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { LoginModalComponent } from '../components/login-modal/login-modal.component';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class LoginService {
  private modalRef: MdbModalRef<LoginModalComponent> | null = null;

  constructor(
    private keycloakService: KeycloakService,
    private modalService: MdbModalService,
  ) {}

  /**
   * Opens the Keycloak login page in a modal when the app is served from the
   * Keycloak origin (frame-ancestors 'self' forbids framing anywhere else);
   * otherwise falls back to the full-page redirect flow.
   *
   * @param redirectPath app path to land on after login, e.g. '/doc/trade/...'
   */
  async login(redirectPath: string = ''): Promise<void> {
    const keycloakOrigin = new URL(environment.keycloakConfig.url).origin;
    if (keycloakOrigin === window.location.origin) {
      if (this.modalRef) {
        return; // a login modal is already open (e.g. several 401s at once)
      }
      this.modalRef = this.modalService.open(LoginModalComponent, {
        // top-aligned at the same offset as the registration modal
        modalClass: 'login-modal-dialog',
        data: { redirectPath },
      });
      this.modalRef.onClose.subscribe(() => (this.modalRef = null));
      return;
    }

    if (!redirectPath) {
      history.pushState({}, '', '/');
    }
    await this.keycloakService.login({
      redirectUri: window.location.origin + redirectPath,
    });
  }
}
